import * as React from 'react';
import {Box, Grid, useMediaQuery} from "@mui/material";


function InviteResponseAppBar({children}) {
    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'));

    return (
        <>
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
            >
                <Grid item xs={8}>
                    <Box fixed sx={matches ? style.mainView.sm : style.mainView.xs}>
                        {children}
                    </Box>
                </Grid>
            </Grid>
        </>
    );
}

export default InviteResponseAppBar;

const style = {
    mainView:
        {
            sm: {
                overflow: 'auto',
                bgcolor: 'background.main',
                width: '60vw',
                height: '100vh'
            },
            xs: {
                overflow: 'auto',
                bgcolor: 'background.main',
                height: '100vh'
            }
        },
}